import { css } from '@emotion/react';
import React, { ReactElement, ReactNode } from 'react';

import { styled } from '../../../styled';

type Interface = { className: string; children: ReactNode; onCloseClick: VoidFunction };

const styles = css`
	align-items: center;
	box-sizing: border-box;
	display: flex;
	flex-flow: column;
	height: 100%;
	justify-content: center;
	left: 0;
	padding: 0 5%;
	position: absolute;
	top: 0;
	width: 100%;
	z-index: 100;

	& > .icon {
		color: white;
		cursor: pointer;
		position: absolute;
		right: 18px;
		top: 18px;
	}
`;

const Component = ({ children, onCloseClick, ...props }: Interface): ReactElement => {
	return (
		<div {...props}>
			{children}
			<svg className="icon" width="24px" height="24px" onClick={onCloseClick} fill="none" viewBox="0 0 24 24">
				<path
					d="m13.412 12 4.295-4.295a.997.997 0 1 0-1.412-1.412L12 10.588 7.705 6.293a.997.997 0 1 0-1.412 1.412L10.588 12l-4.295 4.295a.997.997 0 1 0 1.412 1.412L12 13.412l4.295 4.295a.997.997 0 1 0 1.412-1.412L13.412 12Z"
					fill="#fff"
				/>
			</svg>
		</div>
	);
};

export const DarkenedContainerBase = styled(Component)(styles);
